import React from "react";
import { useTranslation } from "react-i18next";
import { LICENSE_OPTIONS } from "./Step2LicenseChoice";

const Step5SubscribeGate = ({ answers }) => {
  const { t } = useTranslation();

  const trialEnd = (() => {
    const date = new Date();
    date.setDate(date.getDate() + 90);
    try {
      return date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch (error) {
      return date.toISOString().split("T")[0];
    }
  })();

  return (
    <div className="onboarding-step onboarding-step--subscribe">
      <h2 className="onboarding-step__title">
        {t("homeModalWelcome.step5.title")}
      </h2>
      <p className="onboarding-step__description">
        {t("homeModalWelcome.step5.description")}
      </p>

      <div className="onboarding-summary">
        <div className="onboarding-summary__row">
          <span className="onboarding-summary__label">
            {t("homeModalWelcome.step5.summaryEmail")}
          </span>
          <span className="onboarding-summary__value">
            {answers.email || "-"}
          </span>
        </div>
        <div className="onboarding-summary__row">
          <span className="onboarding-summary__label">
            {t("homeModalWelcome.step5.summaryPhone")}
          </span>
          <span className="onboarding-summary__value">
            {answers.phone || "-"}
          </span>
        </div>
        <div className="onboarding-summary__row">
          <span className="onboarding-summary__label">
            {t("homeModalWelcome.step5.summaryLicense")}
          </span>
          <span className="onboarding-summary__value">
            {answers.licenseChoice === LICENSE_OPTIONS.DEVELOPER
              ? t("homeModalWelcome.step2.optionDeveloper.title")
              : t("homeModalWelcome.step2.optionOwn.title")}
          </span>
        </div>
        <div className="onboarding-summary__row">
          <span className="onboarding-summary__label">
            {t("homeModalWelcome.step5.summaryDesign")}
          </span>
          <span className="onboarding-summary__value">
            {answers.wantsDesignService
              ? t("homeModalWelcome.step4.optionYes")
              : t("homeModalWelcome.step4.optionNo")}
          </span>
        </div>
        <div className="onboarding-summary__row">
          <span className="onboarding-summary__label">
            {t("homeModalWelcome.step5.summaryTrialEnd")}
          </span>
          <span className="onboarding-summary__value">{trialEnd}</span>
        </div>
      </div>

      <div className="onboarding-step__highlight">
        <strong>{t("homeModalWelcome.step5.highlightTitle")}</strong>
        <span>{t("homeModalWelcome.step5.highlightBody")}</span>
      </div>
    </div>
  );
};

Step5SubscribeGate.canAdvance = () => true;

export default Step5SubscribeGate;
